import { useCallback, useEffect, useState, createRef } from 'react'
import { useEffectOnce } from 'usehooks-ts'
import styled from 'styled-components'

const Authors = ({
  tenant,
  colorMode,
  authors,
}: {
  tenant: object
  colorMode?: string
  authors: any[]
}) => {
  const [isMobile, setIsMobile] = useState(false)

  // add a variable that holds a component
  const Author = ({ authorname, unityID, tenant }: any) => {
    // console.log('tenant:', tenant)
    return (
      <span className='author' key={unityID}>
        <a
          href={
            tenant.key !== undefined
              ? `https://www.${tenant.key}.ch/author/${unityID}`
              : '#'
          }
        >
          {authorname}
        </a>
      </span>
    )
  }

  const handleResize = (): void => {
    setIsMobile(window.innerWidth < 711)
  }

  useEffectOnce(() => {
    // set height when window is resized
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  })

  return (
    <AuthorsWrapper>
      {authors &&
        authors.map((person, i) => {
          return (
            <Author
              authorname={authors[i].name}
              unityID={authors[i].unityID}
              tenant={tenant}
              key={'author-' + i}
            />
          )
        })}
    </AuthorsWrapper>
  )
}

const AuthorsWrapper = styled.div`
  color: var(--text-color);
  font-size: 1.2rem;
  font-family: var(--font-sans-serif);
  line-height: 1.8rem;
  width: 100%;
  max-width: 668px;
  @media only screen and (max-width: 711px) {
    max-width: 80%;
  }
  text-align: center;
  margin: 0 auto 0.4rem;
  padding-top: 3rem;
  .author {
    a {
      color: var(--text-color);
      text-decoration: none;
      border-bottom: 1px solid var(--text-color);
      white-space: nowrap;
    }
    a:hover {
      opacity: 0.6;
    }
  }

  span::after {
    content: ', ';
  }
  span:last-child::after {
    content: '';
  }
  z-index: 10;
  position: relative;
`

export default Authors
